<template>
  <div class="administration-news-wrapper">
    <div class="news-header">
      <h2>Съобщение</h2>
      <button @click="openMessageModal()">НОВА ПУБЛИКАЦИЯ</button>
    </div>
    <div class="news-container">
      <div
        class="news-item"
        v-for="m in messages"
        :key="m._id"
        @click="(messageModal = true), (selectedMessage = m._id)"
      >
        <p>
          <span class="news-item-date">{{ m.date | formatDateDot }}</span>
          {{ m.bg.title }}
        </p>
      </div>
    </div>
    <transition name="fade">
      <MessageModal v-if="messageModal" :id="selectedMessage" />
    </transition>
  </div>
</template>

<script>
import MessageModal from "./MessageModal";
export default {
  components: {
    MessageModal,
  },
  data() {
    return {
      messageModal: false,
      messages: [],
      selectedMessage: null,
    };
  },
  watch: {
    $route() {
      this.getMessages();
    },
  },
  methods: {
    openMessageModal() {
      this.messageModal = true;
    },

    closeMessageModal(refresh) {
      this.messageModal = false;
      this.selectedMessage = null;
      if (refresh) {
        this.getMessages();
      }
    },
    getMessages() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/message`)
        .then((result) => {
          this.messages = result.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getMessages();

    this.$on("close-news-modal", this.closeMessageModal);
  },
  destroyed() {
    this.$off("close-news-modal");
  },
};
</script>

<style lang="scss" scoped>
.administration-news-wrapper {
  width: 900px;
  margin: 0 auto;
}
.news-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 10px;
  width: 100%;
  h2 {
    color: #004785;
    font-size: 14px;
    font-weight: 500;
  }
  button {
    background-color: $mainColor;
  }
}
.news-container {
  margin: 0 auto;
  width: 100%;
}
.news-item {
  background-color: #fff;
  cursor: pointer;
  margin-bottom: 10px;
  padding: 15px;
  @include transition(all 0.3s);
  .news-item-date {
    color: #cdd8e2;
    display: inline-block;
    margin-left: 5px;
    margin-right: 20px;
  }
  p {
    color: #14478a;
    font-size: 12px;
    font-weight: 500;
  }
}
.news-item:hover {
  background-color: $bgColor3;
  opacity: 0.8;
}
@media screen and (max-width: 1280px) {
  .administration-news-wrapper {
    width: 100%;
    // margin: 0 auto;
  }
}
@media screen and (max-width: 1000px) {
  .administration-news-wrapper {
    display: none;
  }
}
</style>
